import { useState } from 'react';
import FilePreviewModal from './FilePreviewModal';
import {baseURL} from "../Constant";
import axios from 'axios';
import { useSelector } from "react-redux";
import "./FilePreviewAndSubmit.css";

const FilePreviewAndSubmit = (props) => {
  const [modalOpen, setModalOpen] = useState(false);  
  const [tempFile, setTempFile] = useState("");  
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); 
  
  const userID = useSelector((state) => state.model.userID);

  const handleOpen = () => {    
    setModalOpen(true);
  };

  const handleReplace = async (requestType) => {                
    setLoading(true);
    props.setCertificateLoading(true);
    requestType === 'submit' && props.setIsCertificateGenerationClicked(true);                
    try {
        const response = await axios.post(`${baseURL}/pptx/replace-text`, {
          textReplacements: {
            "(program)": props.programNameCertificate,
            "(date)": props.programDateCertificate,
            "(name)": props.signatures[props.selectedSignature].enterprise_id,
            "(designation)": props.signatures[props.selectedSignature].designation,
          },
          imageReplacements: {
            "(signature)": props.signatures[props.selectedSignature].stored_filename,
          },
          selectedSignature: props.signatures[props.selectedSignature].stored_filename,
          categoryCertificate: props.categoryCertificate,
          template: props.selectedTemplate,
          requestType: requestType
          }, {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );        
        const file = response.data.file;                
        if(requestType === 'submit') {
          AddCertificateRequest(file);          
        } 
        if(requestType === 'preview') {
          setTempFile(file);
        }
        setLoading(false);                                                  
    } catch (err) {                        
        setError(err.response.data.message || err.message);
        setLoading(false);
    }        
  };

  const handlePreview = () => {
    if(handleValidation()) {
      setError("");
      handleReplace('preview');                
    } else {
      setError("All required fields must be filled in.");
    }    
    handleOpen();
  }

  const AddCertificateRequest = async (originalFile) => {
    try {
        const response = await axios.post(`${baseURL}/pptx/addPreApprovedCertificate`, {
            certificationData: {
              category: props.categoryName,
              subCategory: props.mailerParent,
              type: props.mailerChild,
              programname: props.programNameCertificate,
              user: userID                                                    
            },
            outputFile: originalFile
          }, {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );        
        const file = response.data.outputFileName;     
        props.setPptLink(file);       
        props.setCertificateLoading(false);                                                            
    } catch (err) {                        
        setError(err.response.data.message || err.message);        
    }
  }

  const handleSubmit = () => {
    if(handleValidation()) {
      setError("");      
      handleReplace('submit');      
    } else {
      setError("All required fields must be filled in.");
      handleOpen();
    }        
  }

  const handleValidation = () => {
    if(!props.campaignRadio || !props.programNameCertificate || !props.programDateCertificate || !props.categoryCertificate 
      || !props.selectedTemplate || (props.selectedSignature === '')
    ) {            
      return false;
    } else {
      return true;       
    }    
  }

  return (
    <>
      <div className='file_preview'>
        <button onClick={handlePreview}>          
          Preview
        </button>                           
        {(tempFile  || error || loading) && <FilePreviewModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}        
          fileName={tempFile}
          error={error}
          loading={loading}
        />}              
      </div>
      <div className='preapproved_submit'>        
        <button onClick={handleSubmit}>          
          Submit
        </button>
      </div>
    </>    
  );
};

export default FilePreviewAndSubmit;